
import { Component, Vue, Prop } from 'vue-property-decorator';
import { TOPN_VALUES, TOPN_ALL, isLimited, describeTopn, getColumnLabel } from '@/helpers/segmentTopn';

@Component
export default class SegmentTopNSetting extends Vue {
  @Prop({ default: TOPN_ALL })
  public value!: string;
  @Prop({ default: '' })
  public sortBy!: string;
  @Prop({ default: true })
  public sortDesc!: boolean;
  @Prop({ default: () => [] })
  public columns!: any[];
  @Prop({ default: false })
  public disabled!: boolean;

  public get topnItems() {
    const items = TOPN_VALUES.map(item => ({
      text: item === TOPN_ALL ? 'all' : `top ${item}`,
      value: item,
    }));
    // keep a value coming from an older segment even when it is not in the list
    if (this.value && !TOPN_VALUES.includes(String(this.value))) {
      items.unshift({ text: `top ${this.value}`, value: String(this.value) });
    }
    return items;
  }

  public get isLimitedValue() {
    return isLimited(this.value);
  }

  public get sortLabel() {
    return getColumnLabel(this.sortBy, this.columns);
  }

  public get summary() {
    return describeTopn(this.value, this.sortBy, this.sortDesc, this.columns);
  }

  public onTopnChange(value: string) {
    this.$emit('input', value);
  }
}
